import SignInForm from '../../forms/SignInForm/SignInForm.vue'

export default{
    components: {SignInForm}
}